import { CustomStatusModalStyle } from './CustomStatusModal.style'

// This is referenced in src/themes/defaultTheme.ts
export const customStatusModalComponentStyles = {
  components: {
    CustomStatusModalStyle,
  },
}
